import React from 'react'

const planningDetails = () => {
  return (
    <div>planningDetails</div>
  )
}

export default planningDetails